import React from 'react';
import { OrderItem } from '../../../hooks/useOrder';
import { RequestReturnPrintableLabelButton } from './RequestReturnPrintableLabelButton';

interface Props {
  item: OrderItem;
}

export const RequestReturnPrintableLabel: React.FC<Props> = ({ item: { attributes } }) => {
  const { status, shippingStatus } = attributes;

  if (status !== 'return_requested') return null;

  if (typeof shippingStatus === 'string') return null;

  if (!shippingStatus?.request_number) return null;

  return <RequestReturnPrintableLabelButton shipmentNumber={shippingStatus?.request_number} />;
};
